/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import EndProjectMultiForm from './EndProjectMultiForm/EndProjectMultiForm';
import EndProjectMultiSuccess from './EndProjectMultiSuccess/EndProjectMultiSuccess';
import EndProjectMultiError from './EndProjectMultiError/EndProjectMultiError';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  project: Object,
  actionDrawerStore: TypeActionDrawerStore,
  projectDetailsStore: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'projectDetailsStore')
@observer
export default class EndProjectMulti extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore, projectDetailsStore }: TypeProps = this.props;
    const project: Object = this.props.project;
    const fields: Array<Object> = [
      {
        name: 'endProjectForm',
        label: t('general:actions.end_project_plural'),
        title: 'End Projects',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_ending_projects'),
            rules: 'required',
            value: '',
            type: 'select',
            placeholder: t('general:placeholders.select_reason'),
            options: [
              {
                id: 1,
                label: t('general:reasons.options.projects_complete'),
              },
              {
                id: 2,
                label: t('general:reasons.options.projects_cancelled'),
              },
              {
                id: 3,
                label: t('general:reasons.options.projects_on_hold'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const projectIds = project.map(p => p.id);

        const { reason } = data.values().endProjectForm;

        actionDrawerStore.endProjectMulti({
          end_reason: reason,
          project_ids: projectIds,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: t('general:actions.end_project_plural'),
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const project: Object = this.props.project;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.end_project_plural')} />
          <EndProjectMultiError response={actionDrawerStore.errorResponse} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.archived}`}>
          <ActionDrawerHeader title={t('general:actions.end_project_plural')} />
          <EndProjectMultiSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.end_project_plural')} />
        <EndProjectMultiForm project={project} form={this.createForm()} />
      </div>
    );
  }
}
